import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import "modules/segments/lang"

export const Route = createFileRoute("/_base/_auth/customers/segments")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("segments.title"),
    })
  },
})
